import React, { useState, useEffect, useRef, useCallback  } from 'react';
import useHTTP from "@/hooks/useHTTP.mjs";
// import Hexagon from '../FormilyPreview/components/Hexagon.jsx'
import Arrow from './Arrow.jsx'
import Modal from "@/components/Modal/Modal";
import { Button, message } from 'antd';
import SoftwareMap from "@/components/SoftwareMap/SoftwareMap.jsx";
import normalizeUrl from '@/biz/normalizeUrl.mjs'

const EventBtn = ({btnData, handleFetchMap}) => {
  const [bgSvg, setBgSvg] = useState('');
  const elementRef = useRef(null);

  useEffect(() => {
    if (elementRef.current) {
      // 首次获取宽度
      const width = elementRef.current.offsetWidth;
      setBgSvg(Arrow(width))
    }
  }, [])

  return (<div 
    ref={elementRef}
    style={{ display: 'inline-block', width:'max-content', backgroundImage: `url('${bgSvg}')`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover', padding: '2px 16px 2px 20px', lineHeight: '28px', marginBottom: '20px', cursor: 'pointer'}}
    onClick={(e) => {
      handleFetchMap(btnData)
    }}
  >
    {btnData.name}
  </div>)
}

// 图片预览组件（左侧图片，右侧操作按钮）
export default ({prjData, data}) => {
  const [actionData, setActionData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [mapData, setMapData] = useState({});
  const http = useHTTP();
  const params = new URLSearchParams(location.search.split("?")[1]);

  useEffect(() => {
    if(prjData.prjId) fetchData(prjData);
  }, [prjData.prjId, prjData.bfCode]);

  const fetchData = async (prjData) => {
    if(!prjData.bfCode) return;
    setActionData([]);
    try {
      /** @name 获取当前流程图的所有业务场景 */
      const param = {
        stsCodes: 'RLS,REVISE',
        sortMode: 1,
        algType: 'DATAFLOW',
        prjId: prjData.prjId,
        bfCode: prjData.bfCode,
        sVer: prjData.sVer,
      }
      let url = '/bmbfs/scenes';
      if(params.get('prjPatternId')) {
        param.prjPatternId = params.get('prjPatternId');
        url = '/pattern/bmbfs/scenes';
      }
      http.get(url, param).then((response) => {
        // 获取response数组中的algTitle的数组，并去重
        const data = response.map((item) => ({  name: item.algTitle, id: item.pkid })).reverse()
        setActionData(data || []);
      }).catch(err => {
        console.log(err);
      });
      
    } catch (error) {
      console.log(error);
    }
    
  };

  const handleFetchMap = useCallback(async (algData) => {
    const param = {}
    let url = `/bmbfs/scene/${algData.id}`;
    if(params.get('prjPatternId')) {
      param.prjPatternId = params.get('prjPatternId');
      url = `/pattern/bmbfs/scene/${algData.id}`;
    }
    http.get(url, param).then((res) => {
      const { algMap, ...data } = res;
      const newData = {
        ...data,
        bizNodeType: "BFDATAFLOW",
        children: JSON.parse(algMap),
      };
      setMapData({
        root: newData,
      });
      showModal();
    })
    .catch((err) => {
      message.error(err.message);
    });
  }, [])

  const showModal = () => {
      setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setMapData({});
  };

  return (
    <>
      <div
        className="w-full flex gap-4 p-4 "
        style={{ height: "calc(100vh - 60px)" }}
      >
        <div
          className="grow flex h-full overflow-y-auto items-center justify-center border-[1px] border-[#0099CC]"
          style={{ boxShadow: "0 0 4px #0099CC" }}
        >
          {!!data.fileId ? (
            <img
              className="max-w-full max-h-full"
              src={normalizeUrl(`/files/${data.fileId}`)}
              alt="预览图"
            />
          ) : (
            <div className="no-image">
              <div>{data.wfName || ""}</div>
            </div>
          )}
        </div>
        <div className="w-[200px] text-center py-4 flex flex-col gap-1 h-full overflow-y-auto items-center">
          {actionData.map((btn, index) => (
            <EventBtn
              btnData={btn}
              handleFetchMap={handleFetchMap}
              key={index}
            />
          ))}
          {actionData.length == 0 && <div className="no-action">暂无数据</div>}
        </div>
      </div>
      <Modal
        title="业务场景"
        open={isModalOpen}
        width={"70%"}
        bodyStyle={{ height: "calc(78vh - 100px)" }}
        centered
        destroyOnClose
        onCancel={handleCancel}
        footer={[
          <Button key="back" onClick={handleCancel}>
            关闭
          </Button>,
        ]}
      >
        <SoftwareMap mapData={mapData} />
      </Modal>
    </>
  );
};
